import { connect } from "react-redux";
import PerformanceScoreSummary from "./components/PerformanceScoreSummary";
import AttendanceSummary from "./components/AttendanceSummary";
import ProductivityMetrics from "./components/ProductivityMetrics";
import HRComplianceStanding from "./components/HRComplianceStanding";
import ActiveGoalsSummary from "./components/ActiveGoalsSummary";
import PerformanceTrend from "./components/PerformanceTrend";


const PerformanceGoals = () => {
  return (
    <div className="space-y-4">
		<PerformanceScoreSummary/>
		<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
			<AttendanceSummary/>
			<ProductivityMetrics/>
		</div>
		<HRComplianceStanding/>
		<ActiveGoalsSummary/>
		<PerformanceTrend/>
    </div>

  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceGoals);
